<script lang="ts" setup>
import type { Data } from '~~/server/api/officeservice/offices'

export interface MapModalOfficeProps {
    office: Data
    title?: string
    type?: string
}

const props = defineProps<MapModalOfficeProps>()

const { data, sendEvent } = useTracker()

const getClosingHours = (): string => {
    const currentDayIndex = new Date().getDay() -1
    return props.office.opening_hours?.[currentDayIndex]?.to_time ?? ''
}

const officeHeading = props.title ? props.title : props.office.title
const title = `${officeHeading} / ${props.office.address}, ${props.office.zip_code} ${props.office.city}`

const handleClick = (label: string) => {
    sendEvent({
        data: {
            ...data,
            title,
            click: label,
        },
    })
}
</script>
<template>
  <article>
    <Tracker :data="{ title }">
      <p
        v-if="props.title"
        class="fs-xsmall fw-normal mb-1 text-uppercase"
      >
        {{ props.title }}
      </p>
      <h4
        class="delta"
        tabindex="0"
        :aria-label="`Názov pobočky: ${props.office.title}`"
      >
        {{ props.office.title }}
      </h4>
      <Typo
        class="mb-3"
        :aria-label="`Adresa pobočky: ${props.office.address}, ${props.office.zip_code} ${props.office.city}`"
      >
        <p class="fw-bold fs-bigger mb-0">
          {{ props.office.address }}
          <br>
          {{ props.office.zip_code }} {{ props.office.city }}
        </p>
      </Typo>
      <p
        v-if="props.office.is_open_now"
        class="mb-3"
      >
        <span class="text-green-5">{{ $t('Otvorené') }},</span>
        {{ $t('zatvárame o') }} {{ getClosingHours() }}
      </p>
      <ul
        v-if="(props.office.offices_phone_numbers_on && props.office.phone_contacts.length > 0) || props.type === 'services'"
        class="mb-6"
      >
        <li
          v-for="(phone, index) in props.office.phone_contacts"
          :key="`mpofdm-${index}`"
          :class="{
            'mb-2': index < props.office.phone_contacts.length - 1,
          }"
        >
          <a
           
            class="d-flex align-items-center fs-smaller"
            :href="`tel:${phone.international_format}`"
            @click="() => handleClick(phone.international_format)"
          >
            <svg
              aria-hidden="true"
              class="text-secondary d-block me-2"
              width="14"
              height="14"
            >
              <use xlink:href="#phone" />
            </svg>
            {{ phone.international_format }}
          </a>
        </li>
      </ul>
      <slot name="button" />
      <IconsWrapper>
        <IconsSymbolPhone />
      </IconsWrapper>
    </Tracker>
  </article>
</template>
